import { InputSlider } from '@web/vitafy-react-components';
import { sendGAEvent, convertValueToIntegers } from '!/common/helpers';
import { filter } from 'lodash';


const Slider = props => {
    const { name, aggs, values, update, filterName } = props;
    const prices = {max: 50, min: 5}; //TODO get them dynamically from BE
  
    const track = (value) => {
      sendGAEvent('Search Filter', 'filter switched', filterName);
      sendGAEvent("Search Filter", "name", value);
    };
  
    const min = values[filterName] ? (values[filterName][0] || prices.min) : prices.min;
    const max = values[filterName] ? (values[filterName][1] || prices.max) : prices.max;

    const onPriceChange = v => {
      const values = convertValueToIntegers(v);
      if (values[0] === min && values[1] === max) {
          return;
      }
      track(v);
      update (filterName, values);
    };

    return <InputSlider  {...{onChange: onPriceChange, handleMin: min, handleMax: max, priceMin: 5, priceMax:50 }} />;

};

export default Slider;
